import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles({
  toTop: {
    zIndex: 2,
    position: 'fixed',
    bottom: '2vh',
    backgroundColor: '#FCB718',
    color: '#162952',
    height: '56px',
    width: '56px',
    '&:hover, &.Mui-focusVisibile': {
      transition: '0.3s',
      backgroundColor: '#FCB718',
      color: '#162952',
    },
    right: '3%',
  },
});

interface ScrollBackType {
  showBelow: Number;
}

const ScrollBack = ({ showBelow }: ScrollBackType) => {
  const classes = useStyles();
  const [show, setShow] = useState(false);

  /* istanbul ignore next */
  const handleScroll = () => {
    if (window.pageYOffset > showBelow) {
      setShow(true);
    } else setShow(false);
  };

  useEffect(() => {
    if (showBelow) {
      window.addEventListener(`scroll`, handleScroll);
      return () => window.removeEventListener(`scroll`, handleScroll);
    }
  });

  /* istanbul ignore next */
  const handleClick = () => {
    window[`scrollTo`]({ top: 0, behavior: `smooth` });
  };
  return (
    <div>
      {show && (
        <IconButton onClick={handleClick} className={classes.toTop}>
          <ArrowUpwardIcon />
        </IconButton>
      )}
    </div>
  );
};

export default ScrollBack;
